import { Box, Typography, CircularProgress } from "@mui/material";
import React, { useState, useEffect } from "react";
import ModalContent from "src/Shared/Components/ModalContent/ModalContent";
import { useModal } from "src/Shared/Hooks";
import { ISelectOption, ITrainingArticle } from "src/Shared/Interfaces";
import CommonService from "src/Shared/Services/Common.service";

type Props = {
  industries?: ISelectOption[];
  selectedIndustryId?: any;
};

const IndustryInfoDialog: React.FC<Props> = () => {
  const { close } = useModal();
  const [trainingArticle, setTrainingArticle] = useState<ITrainingArticle | null>(null);
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    const sub = CommonService.getCrmTrainingArticle().subscribe({
      next: (article) => {
        setTrainingArticle(article);
        setLoading(false);
      },
      error: (err) => {
        console.error("Failed to load training article", err);
        setLoading(false);
      },
    });
    return () => sub.unsubscribe();
  }, []);

  return (
    <ModalContent
      title={trainingArticle?.title || ""}
      buttonText="Close"
      onSaveButtonClick={close}
      maxWidth="lg"
    >
      <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
        {loading ? (
          <Box sx={{ display: "flex", justifyContent: "center", py: 4 }}>
            <CircularProgress />
          </Box>
        ) : trainingArticle ? (
          <Box>
            <Typography
              variant="body2"
              color="text.secondary"
              sx={{
                lineHeight: 1.6,
                "& p": { my: 1 },
                "& ul, & ol": { pl: 2.5, my: 1 },
                "& li": { my: 0.5 },
              }}
              component="div"
              dangerouslySetInnerHTML={{ __html: trainingArticle.content }}
            />
          </Box>
        ) : null}
      </Box>
    </ModalContent>
  );
};

export default IndustryInfoDialog;
